import React from "react";
import styles from "./Privacy.module.css";

const Privacy = () => {
  return (
    <div className={styles.main}>
      <h1>Crest Digitel Privacy Policy</h1>
      <p>
        Crest Digitel Private Limited and all other related affiliates and
        subsidiaries (collectively “Crest Digitel”, “we” or “us”) value your
        privacy. We are committed to protecting the privacy of your personal
        information. Crest Digitel will use the information we collect from you
        in accordance with this policy.
      </p>
      <p>
        The policy describes how we use your personal data when you use our
        website (www.crestdigitel.com). We have provided this policy to ensure
        that individuals who use our website understand what personal data we
        may collect and hold about them, what we may use it for and how we keep
        it safe. You have legal rights to access the personal data that we hold
        about you and to control how we use it which are also explained in this
        policy.
      </p>
      <p>
        Please read this privacy policy carefully. Your use of the site and/or
        the services, including your disclosure of any personal information into
        the site and/or services, is subject to and governed by this policy. By
        visiting www.crestdigitel.com, you are accepting the practices described
        in this policy.
      </p>
      <div>
        <span>Who We Are</span>
        <p>
          Crest Digitel Private Limited is one of the leading and fastest
          growing Digital Connectivity Infrastructure companies dedicated to
          providing innovative and customized solutions. Backed by a strong
          global parentage, we are committed to revolutionizing people’s lives
          by seamlessly connecting them at any time and from any location. This
          commitment is evidenced by the company’s 50%+ market share in the IBS
          business, 10 million+ daily touchpoints, an excellent uptime of
          99.99%, and a nationwide presence covering 22 telecom circles.
        </p>
      </div>
      <div>
        <span>Information We Collect</span>
        <p>
          We collect and store information that you voluntarily provide to us,
          information related to your site visit and usage, as well as
          information provided to us by or through our clients in connection
          with our services.
        </p>
      </div>
      <div>
        <span>Information You Provide</span>
        <p>
          Personal information that you provide directly to us will be apparent
          from the context in which you provide it, for example:{" "}
        </p>
        <p>
          1. If you request information from us using the online form on our
          “Contact Us” page, you are required to provide us with personal
          information such as first name, last name, email, website, contact
          details, and your message.
        </p>
        <p>
          2. If you sign up for any of the online services we provide, you will
          generally provide your name and contact information and any other
          information necessary to access the feature
        </p>
        <p>
          3. If you sign up to receive electronic communications from us, you
          will generally provide your name, email address and other contact
          information, and your preferences.
        </p>
        <p>
          4. If you wish to apply for a position with our company you are
          required to provide us your name and resume and if you apply using
          your LinkedIn profile, you will generally provide information about
          your LinkedIn account.
        </p>
        <p>
          5. If you are a key contact in a business that has a business account
          with Crest Digitel, we generally have your name, email address, phone
          number, title and other information relevant to your interaction with
          Crest Digitel on behalf of your employer.
        </p>
      </div>
      <div>
        <span>Information That We Collect Automatically</span>
        <p>
          <span>Cookies:</span>We use cookies to understand site usage and to
          improve the content and offerings on our Site. For example, we may use
          cookies to personalize your experience on our web pages (e.g. to
          recognize you by name when you return to our site). We also may use
          cookies to offer you services. Other non-personal information: We
          automatically gather certain non-personal information like internet
          protocol (IP) addresses, browser type, internet service provider
          (ISP), referring/exit pages, operating system, date/time stamp, and
          clickstream data from visitors to our website and store that
          information in log files. This information is used to analyze trends
          and to administer the site to track movements around the site and to
          gather demographic information about our user base as a whole.
        </p>
      </div>
      <div>
        <span>Use Of Information</span>
        <p>We may use your personal information you submit to the Site to:</p>
        <p>1. Contact you to deliver certain information you have requested.</p>
        <p>
          2. Contact a customer or a partner about the services that we think
          may be of interest to you.
        </p>
        <p>3. Verify your authority to enter our site.</p>
        <p>4. Consider your eligibility for employment.</p>
        <p>
          5. To obtain feedback through surveys regarding our services, our
          website, or other aspects of our business.
        </p>
        <p>
          6. Address any queries or provide necessary information/resources.
        </p>
        <p>
          7. Contact the users who have provided their information with respect
          to any service line; and for our records.
        </p>
      </div>
      <div>
        <span>Disclosure Or Sharing of Information</span>
        <p>
          We will not rent or sell your personal information to any company or
          organization. We may disclose or share personal information about our
          customers/partners to our affiliates, as permitted by law, for our
          affiliates to provide services. We also may share your personal
          information with service providers that perform services on our
          behalf, such as hosting providers and advisers. We may share personal
          information with our affiliates and service providers for a number of
          reasons, including:
        </p>
        <p>1. You have requested information about our affiliates’ services.</p>
        <p>
          2. We rely on services provided by our affiliates and service
          providers to provide you with the services you require.
        </p>
        <p>
          3. If we are required to do so by law, regulation, or other government
          authority
        </p>
      </div>
      <div>
        <span>Links To Third Party Sites</span>
        <p>
          The site may provide links to other websites or resources over which
          Crest Digitel does not have control (“external websites”). Such links
          do not constitute an endorsement by Crest Digitel of those external
          websites. Your use of external websites is subject to the terms of use
          and privacy policies located on external websites.
        </p>
      </div>
      <div>
        <span>Security of Data</span>
        <p>
          We have Data Sharing Policy in place to protect the confidentiality
          and integrity of your Information. We maintain strict physical,
          electronic, and administrative safeguards to protect all information
          including your personal information from unauthorized or inappropriate
          access.
        </p>
      </div>
      <div>
        <span>How Long Do We Keep Personal Information</span>
        <p>
          The time period for which we keep personal information depends on the
          purpose for which we collect it. In all cases, we keep it for as long
          as is necessary to fulfill the purposes for which we collected it. We
          will then delete or anonymize the personal information unless we are
          legally required to retain it.
        </p>
      </div>
      <div>
        <span>Limitation Of Liability</span>
        <p>
          To the extent permissible under the law, we shall not be liable for
          any direct, indirect, incidental, special, consequential or exemplary
          damages, including but not limited to, damages for loss of profits,
          goodwill, data, information, or other intangible losses (even if we
          have been advised of the possibility of such damages), arising out of
          this privacy policy.
        </p>
      </div>
      <div>
        <span>Changes To This Privacy Policy</span>
        <p>
          We may update this privacy policy from time to time. Additionally, you
          are encouraged to check this privacy policy on a regular basis to be
          aware of the changes made to it.
        </p>
      </div>
      <div>
        <span>Applicable Laws</span>
        <p>
          The privacy and protection of personal data or information is mandated
          under Section 43A of Information Technology Act, 2000 read with
          Information Technology (Reasonable Security Practices and Procedures
          and Sensitive Personal Data or Information) Rules, 2011
        </p>
      </div>
      <div>
        <span>Governing Law And Jurisdiction</span>
        <p>
          This Privacy Policy is governed by and operated in accordance with the
          laws of India. If any of the parties wish to seek legal recourse, they
          may do so by using the courts of law In Delhi having exclusive
          jurisdiction.
        </p>
      </div>
      <div>
        <span>How To Contact Us</span>
        <p>
          If you have any questions or comments about this privacy policy, or
          about how your personal information is processed you may contact us: –
          info@crestdigitel.com
        </p>
      </div>
    </div>
  );
};

export default Privacy;
